import type { Style } from "@bezpart-board/shared";
import type { SceneObject } from "../../SceneHost";
import {
  applyStrokeDashAttr,
  pathLinejoin,
  pathStrokeColor,
  pathStrokeDash,
  pathStrokeWidth,
  readObjectStyle,
} from "../../../lib/board/sceneStyle";

type PaintTarget =
  | SVGRectElement
  | SVGEllipseElement
  | SVGPathElement
  | SVGCircleElement
  | SVGPolygonElement;

export function shapeFill(obj: SceneObject): string {
  const fill = readObjectStyle(obj).fill;
  if (fill === "none" || fill === undefined) return "none";
  return fill;
}

export function shapeFillOpacity(obj: SceneObject): number | undefined {
  return readObjectStyle(obj).fillOpacity;
}

export function applyShapePaint(el: PaintTarget, obj: SceneObject): void {
  const strokeWidth = pathStrokeWidth(obj);
  const dash = pathStrokeDash(obj);
  el.setAttribute("stroke", pathStrokeColor(obj));
  el.setAttribute("stroke-width", String(strokeWidth));
  el.setAttribute("stroke-linejoin", pathLinejoin(obj));
  el.setAttribute("fill", shapeFill(obj));
  const fillOpacity = shapeFillOpacity(obj);
  if (typeof fillOpacity === "number") {
    el.setAttribute("fill-opacity", String(fillOpacity));
  } else {
    el.removeAttribute("fill-opacity");
  }
  const strokeOpacity = readObjectStyle(obj).strokeOpacity;
  if (typeof strokeOpacity === "number") {
    el.setAttribute("stroke-opacity", String(strokeOpacity));
  } else {
    el.removeAttribute("stroke-opacity");
  }
  if (dash !== "wavy") {
    applyStrokeDashAttr(el, dash, strokeWidth);
  } else {
    el.removeAttribute("stroke-dasharray");
  }
}

export function applyShapeStyleFields(settings: {
  stroke: string;
  strokeWidth: number;
  strokeDash?: Style["strokeDash"];
  fill: string;
}): Style {
  return {
    stroke: settings.stroke,
    strokeWidth: settings.strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDash: settings.strokeDash ?? "solid",
    fill: settings.fill,
  };
}
